import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./loadingContainer.css";
import Typography from "@mui/material/Typography";

const LoadingContainer = ({
  message = "",
  size = 35,
  hasBackground = true,
  hasFixedHeight = true,
  ...rest
}) => {
  return (
    <div
      className={
        "app-loading-container " +
        (hasBackground ? "app-loading-container-bg " : "") +
        (hasFixedHeight ? "app-loading-container-200 " : "")
      }
      {...rest}
    >
      <CircularProgress
        className="app-circular-progress"
        color="secondary"
        size={size}
      />
      <Typography className="text" variant="body1">
        {message}
      </Typography>
    </div>
  );
};

export default LoadingContainer;
